import script from "./CurrencySwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencySwitcher.vue?vue&type=script&setup=true&lang=js"

import "./CurrencySwitcher.vue?vue&type=style&index=0&id=488b5a63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488b5a63"]])

export default __exports__